import { graphql } from '@e-socna/data-layer';

export const FolderBusinessEntity_FolderBusinessEntityConsolidation_Fragment =
  graphql(`
    fragment FolderBusinessEntity_FolderBusinessEntityConsolidation_Fragment on FolderBusinessEntityConsolidation {
      ...FolderBusinessEntityForm_GeneralInfoStep_Describable_Fragment

      address {
        ...AddressWithMapCmp_Address_Fragment
      }

      internalActors {
        ...ActorsCmp_Actor_Fragment
      }
      externalActors {
        ...ActorsCmp_Actor_Fragment
      }
    }
  `);
